<template>
  <page-template >
    <template slot="page-content">
      <div class="generic--template food-and-drink page-template bg-beige">
        <!-- <div class="parallax">
          <div
            v-scrollanimation
            class="taste-header ph0 ph5-m ph5-l flex fixed-height realtive"
          >
            <h3 class="f1 is-blenny lh-title font-bigger">
              TASTE OF THE <br class="dn db-ns" />BAY AREA
            </h3>
          </div>
        </div> -->

        <div class="relative bg-sf-color z-content">
          <div class="row relative center mb4 mt4-ns">
            <div class="show-mobile relative center col-xs-12 col-sm-6 ph0">
              <div class="w-100  col-sm-6">
                
                <img
                  class="img-responsive"
                  src="/uploads/JoshWithersOSL2018_FriAtmosphere_Withers_jjw1992.jpg"
                /> 
                
              </div>
              <h1
                class="db dn-ns f-page-title ttu tl center lh-heading pr0-ns is-blenny is-navy mw7-ns"
                v-html="marked(page.title)"
              >
              </h1>
              <div
                    class="db des-rest2 relative mb4 mb4-ns w-100 f18px is-tablet-regular link-bold lh-copy cms-content"
                    v-html="marked(page.intro_text)"
                  >
                    <!-- v-if="page.intro_text"
                    v-html="marked(page.intro_text)" -->
                  </div>
            </div>
          </div>
          <div class="show-no-mobile relative container-fluid  mw9 center grass-top">
            <div class="row relative center mb4 mt4-ns">
              <div class="w-100  col-sm-6">
                
                <img
                  class="img-responsive"
                  src="/uploads/JoshWithersOSL2018_FriAtmosphere_Withers_jjw1992.jpg"
                /> 
                
              </div>

              <div class="relative col-xs-12 col-sm-6 ph0">
           
                <h1
                  v-scrollanimation
                  class="db dn-ns f-page-title ttu tl center lh-heading pr0-ns is-blenny is-navy mw7-ns"
                  v-html="marked(page.title)"
                >
                </h1>

                <div class="dn des-rest db-ns abs-vert-center center">
                 
                  <h1
                    class="mw7-ns tl center pl3 fiveem lh-heading ttu is-blenny is-navy"
                    v-html="marked(page.title)"
                  >

                  </h1>

                  <div
                    class="db des-rest2 relative mb4 mb4-ns w-100 f18px is-tablet-regular link-bold lh-copy cms-content"
                    v-html="marked(page.intro_text)"
                  >
                    <!-- v-if="page.intro_text"
                    v-html="marked(page.intro_text)" -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="show-mobile relative center col-xs-12 col-sm-6 ph0">
              
              <!-- <h1
                class="db dn-ns f-page-title ttu tl center lh-heading pr0-ns is-blenny is-navy mw7-ns"
                v-html="marked(page.title)"
              >
              </h1> -->
              <img
                  class="img-responsive"
                  src="/uploads/Eaze_Logo-Lockup_Blue-RGB.png"
                /> 
              <div
                    class="db des-rest2 relative mb4 mb4-ns w-100 f18px is-tablet-regular link-bold lh-copy cms-content"
                    v-html="marked(page.eaze_text)"
                  >
                    <!-- v-if="page.intro_text"
                    v-html="marked(page.intro_text)" -->
                  </div>
                  <div class="w-100  col-sm-6">
                
                <!-- <img
                  class="img-responsive"
                  src="/uploads/Eaze_Logo-Lockup_Blue-RGB.png"
                />  -->
                    <img
                  class="img-responsive eaze-logo"
                  src="/uploads/qr-code-eaze.png"
                /> 
                
              </div>
            </div>
          <div class="show-no-mobile relative container-fluid  mw9 center grass-top2">
            <div class="row relative center mb4 mt4-ns">
              

              <div class="relative col-xs-12 col-sm-6 ph0">
                <!-- <h1
                  v-scrollanimation
                  class="db dn-ns f-page-title ttu tl center lh-heading pr0-ns is-blenny is-navy mw7-ns"
                  v-html="marked(page.eaze_title)"
                >
                </h1> -->
                <div class="dn des-rest db-ns abs-vert-center center">
                 <img
                  class="img-responsive eaze2"
                  src="/uploads/Eaze_Logo-Lockup_Blue-RGB.png"
                /> 
                
                  <!-- <h1
                    class="mw7-ns tl center pl3 fiveem lh-heading ttu is-blenny is-navy"
                    v-html="marked(page.eaze_title)"
                  >

                  </h1> -->
                  <div
                    class="db des-rest2 relative mb4 mb4-ns w-100 f15px is-tablet-regular link-bold lh-copy cms-content"
                  >
                    <!-- v-if="page.intro_text"
                    v-html="marked(page.intro_text)" -->
                    {{ page.eaze_text}}
                  </div>
                </div>
              </div>
                <div class="w-100  col-sm-6">
                
               
                    <img
                  class="img-responsive eaze-logo"
                  src="/uploads/qr-code-eaze.png"
                /> 
                
              </div>

            </div>
          </div>
          <!-- <fixedbg :background="`/uploads/NUM-BEER/OUTSIDE-BEER-${newArray[4]}.jpg`">
        <template slot="contents">
          <accolades-static>
            <template slot="fixed-bg-contents">
              <div class="" v-html="`/uploads/NUM-BEER/OUTSIDE-BEER-${newArray[4]}.jpg`"></div>
            </template>
          </accolades-static>
        </template>
      </fixedbg> -->

          <!-- <div v-scrollanimation class="relative">
                <h1
                  
                  class="db dn-ns f-page-title ttu tl center lh-heading pr0-ns is-blenny is-navy mw7-ns"
                >
                  {{ page.seo_title }}
                </h1>
                <div class="center">
                  <div class="icon-div">
                    <img
                   
                    class="mw21rem icon "
                    src="/uploads/OL20-OL21_Icons/Food_Truck_Icon/Food_Truck_Icon_SVG/FoodTruck_Icon_Infrared.svg"
                  />
                  <img
                    
                    class="mw21rem icon "
                    src="/uploads/OL20-OL21_Icons/Food_Truck_Icon/Food_Truck_Icon_SVG/FoodTruck_Icon_Infrared.svg"
                  />
                  <img
                    
                    class="mw21rem icon "
                    src="/uploads/OL20-OL21_Icons/Food_Truck_Icon/Food_Truck_Icon_SVG/FoodTruck_Icon_Infrared.svg"
                  />
                  <img
                    
                    class="mw21rem icon "
                    src="/uploads/OL20-OL21_Icons/Food_Truck_Icon/Food_Truck_Icon_SVG/FoodTruck_Icon_Infrared.svg"
                  />
                  </div>
                  <h1
                    class="mw7-ns tc center pl3 lh-heading f-page-title ttu is-blenny is-navy"
                  >
                    Restaurant List
                  </h1>
                  <div class="icon-div">
                    <img
                   
                    class="mw21rem icon "
                    src="/uploads/OL20-OL21_Icons/Food_Truck_Icon/Food_Truck_Icon_SVG/FoodTruck_Icon_Infrared.svg"
                  />
                  <img
                    
                    class="mw21rem icon "
                    src="/uploads/OL20-OL21_Icons/Food_Truck_Icon/Food_Truck_Icon_SVG/FoodTruck_Icon_Infrared.svg"
                  />
                  <img
                    
                    class="mw21rem icon "
                    src="/uploads/OL20-OL21_Icons/Food_Truck_Icon/Food_Truck_Icon_SVG/FoodTruck_Icon_Infrared.svg"
                  />
                  <img
                    
                    class="mw21rem icon "
                    src="/uploads/OL20-OL21_Icons/Food_Truck_Icon/Food_Truck_Icon_SVG/FoodTruck_Icon_Infrared.svg"
                  />
                  </div>
                </div>
              </div> -->
          <section class="relative">
            <div class="relative container-fluid center smaller-list rest-list">
              <h1 class="center is-tablet-bold is-navy second-title">
                Partners
              </h1>
              <div class="row center">
                <div class="restaurant-border col-sm-10 mt0 mt4-ns">
                  <!-- <div
                    class="db relative w-100 f22px is-tablet-regular link-bold lh-copy cms-content"
                    v-if="page.restaurant_section.sub_text"
                    v-html="marked(page.restaurant_section.sub_text)"
                  ></div> -->
                  <div v-scrollanimation class="row mt4">
                    
                      <!-- <div class="col-xs-12 col-sm-4 pb4"  v-for="restaurant in page.grantees_section.grantees">
                      <a class="flex relative flex-row items-center auto-margin is-tablet-bold f24px ttn is-navy rest-partner grass-part" :href="restaurant.link" :title="restaurant.title" target="_blank">
                        <h4 class="is-tablet-bold is-black f20px" v-html="marked(restaurant.title)">
                          <simple-svg class="vendor-arrow r45 nl2 pb2 pr1" :filepath="'/uploads/checkout-arrow.svg'"></simple-svg>
                        </h4>
                        <img
                    v-lazy="restaurant.image" :title="restaurant.title"
                    class="grass-pic w100 margin-50-v2"
                  />
                      </a>
                    </div> -->
                    <div class="row">
                        <a v-for="(grantee, index) in page.grantees_section.grantees" class="col-xs-12 col-sm-3 mb3 auto-margin" :href="grantee.link" target="_blank" :title="grantee.title" :key="'grantee-item-' + index">
                          <img class="center w100" v-lazy="grantee.image" :title="grantee.title" />
                          <div class="f4 mv3 lh-copy is-black" v-html="grantee.text"></div>
                        </a>
                      </div>
                    
                  </div>
                </div>
              </div>
              <div class="pic-left">
                <div
                  v-scrollanimation
                  class="dn db-ns bigger-img icon-image relative nt4 nl5-ns"
                >
                  <img
                    v-scrollanimation
                    class="mw21rem icon-2 icon-margin"
                    src="/uploads/OL20-OL21_Icons/CannabisIcon/CannabisIconSVG/Cannabis_Icon_Infrared.svg"
                  />
                  <!-- <img
                    v-scrollanimation
                    class="mw21rem icon-2 icon-margin"
                    src="/uploads/OL20-OL21_Icons/Fork_Knife Icon/Fork_Knife_Icon_SVG/Fork_Knife_Icon_Blue.svg"
                  /> -->
                  <img
                    v-scrollanimation
                    class="mw21rem icon-2 icon-margin"
                    src="/uploads/OL20-OL21_Icons/CannabisIcon/CannabisIconSVG/Cannabis_Icon_Blue.svg"
                  />
                  <img
                    v-scrollanimation
                    class="mw21rem icon-2 icon-margin"
                    src="/uploads/OL20-OL21_Icons/CannabisIcon/CannabisIconSVG/Cannabis_Icon_Infrared.svg"
                  />
                  <!-- <img
                    v-scrollanimation
                    class="mw21rem pic-margin"
                    src="/uploads/NUM-BEER/OUTSIDE-BEER-3.jpg"
                  /> -->
                </div>
              </div>
              <div class="pic-right">
                <div
                  v-scrollanimation
                  class="dn db-ns bigger-img icon-image relative nt4 nl5-ns"
                >
                  <img
                    v-scrollanimation
                    class="mw21rem icon-2 icon-margin"
                    src="/uploads/OL20-OL21_Icons/CannabisIcon/CannabisIconSVG/Cannabis_Icon_Infrared.svg"
                  />
                  <img
                    v-scrollanimation
                    class="mw21rem icon-2 icon-margin"
                    src="/uploads/OL20-OL21_Icons/CannabisIcon/CannabisIconSVG/Cannabis_Icon_Blue.svg"
                  />
                  <!-- <img
                    v-scrollanimation
                    class="mw21rem pic-margin"
                    src="/uploads/NUM-BEER/OUTSIDE-BEER-5.jpg"
                  /> -->
                  
                </div>
              </div>
            </div>
            <div class="relative container-fluid mw9 center"></div>
          </section>
        </div>

        <div
          class="relative bg-light-blue z-content mb5"
          v-if="
            isWindowWidthMobile == true &&
              page.featured_content_section.is_published
          "
        >
          <section class="relative center pv4 is-black">
            <swiper :options="swiperOptions" ref="mySwiper">
              <swiper-slide>
                <div class="relative container-fluid">
                  <div class="db w-100">
                    <img
                      class="db relative center img-responsive w-100"
                      :src="page.featured_content_section.content['0'].image"
                      :alt="
                        page.featured_content_section.content['0'].image.alt
                      "
                    />
                    <h3 class="f20px is-tablet-cond-bold mt4 mb3">
                      {{ page.featured_content_section.content["0"].title }}
                    </h3>
                    <p class="f15px is-tablet-regular mb3 lh-copy">
                      {{ page.featured_content_section.content["0"].text }}
                    </p>
                    <a
                      class="f15px is-tablet-bold"
                      :title="
                        page.featured_content_section.content['0'].link_title
                      "
                      :href="page.featured_content_section.content['0'].link"
                      >{{
                        page.featured_content_section.content["0"].button_text
                      }}<simple-svg
                        class="checkout"
                        :filepath="'/uploads/checkout-arrow.svg'"
                      ></simple-svg
                    ></a>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="relative container-fluid">
                  <div class="db w-100">
                    <img
                      class="db relative center img-responsive w-100"
                      :src="page.featured_content_section.content['1'].image"
                      :alt="
                        page.featured_content_section.content['1'].image.alt
                      "
                    />
                    <h3 class="f20px is-tablet-cond-bold mt4 mb3">
                      {{ page.featured_content_section.content["1"].title }}
                    </h3>
                    <p class="f15px is-tablet-regular mb3 lh-copy">
                      {{ page.featured_content_section.content["1"].text }}
                    </p>
                    <a
                      class="f15px is-tablet-bold"
                      :title="
                        page.featured_content_section.content['1'].link_title
                      "
                      :href="page.featured_content_section.content['1'].link"
                      >{{
                        page.featured_content_section.content["1"].button_text
                      }}<simple-svg
                        class="checkout"
                        :filepath="'/uploads/checkout-arrow.svg'"
                      ></simple-svg
                    ></a>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </section>
        </div>

        <div
          class="relative bg-light-blue z-content mb5 mt4"
          v-if="
            isWindowWidthMobile == false &&
              page.featured_content_section.is_published
          "
        >
          <div class="relative container-fluid">
            <section class="relative center mw8 pt5 pb5 is-black">
              <div class="row">
                <div class="col-xs-12 col-sm-6 pr5-ns br-ns b--is-cream">
                  <img
                    class="db relative center img-responsive w-100"
                    :src="page.featured_content_section.content['0'].image"
                    :alt="page.featured_content_section.content['0'].image.alt"
                  />
                  <h3 class="f20px is-tablet-cond-bold mt4 mb3">
                    {{ page.featured_content_section.content["0"].title }}
                  </h3>
                  <p class="f15px is-tablet-regular  mb3 lh-copy">
                    {{ page.featured_content_section.content["0"].text }}
                  </p>
                  <a
                    class="f15px is-tablet-bold"
                    :title="
                      page.featured_content_section.content['0'].link_title
                    "
                    :href="page.featured_content_section.content['0'].link"
                    >{{ page.featured_content_section.content["0"].button_text
                    }}<simple-svg
                      class="checkout"
                      :filepath="'/uploads/checkout-arrow.svg'"
                    ></simple-svg
                  ></a>
                </div>
                <div class="col-xs-12 col-sm-6 pl5-ns pt5 pt0-m pt0-l">
                  <img
                    class="db relative center img-responsive w-100 pt4 pt0-m pt0-l"
                    :src="page.featured_content_section.content['1'].image"
                    :alt="page.featured_content_section.content['1'].image.alt"
                  />
                  <h3 class="f20px is-tablet-cond-bold mt4 mb3">
                    {{ page.featured_content_section.content["1"].title }}
                  </h3>
                  <p class="f15px is-tablet-regular mb3 lh-copy">
                    {{ page.featured_content_section.content["1"].text }}
                  </p>
                  <a
                    class="f15px is-tablet-bold"
                    :title="
                      page.featured_content_section.content['1'].link_title
                    "
                    :href="page.featured_content_section.content['1'].link"
                    >{{ page.featured_content_section.content["1"].button_text
                    }}<simple-svg
                      class="checkout"
                      :filepath="'/uploads/checkout-arrow.svg'"
                    ></simple-svg
                  ></a>
                </div>
              </div>
            </section>
          </div>
        </div>
        <section class="relative mt6 mt0-ns mb10">
              <div class="relative container-fluid-sm mw8-5 center">
                <h1 class="center is-tablet-bold is-navy second-title">
                The Grass Lands Stage
              </h1>
                <div class="row-one center">

                  <div class="relative col-xs-12 col-sm-4" v-for="(block, index) in page.content_blocks">
                    <div v-if="index === 1" class="dn db-ns top-0 left-0 h-100 absolute center cm-border is-navy"></div>
                    <div v-if="index === 1" class="dn db-ns top-0 right-0 h-100 absolute center cm-border is-navy"></div>
                    <div class="w-100 center ph0 ph3-ns">
                      <img class="mb3 center ml0 w-100 mw100" v-lazy="block.image" />
                      <h2 class="f2 tl is-tablet-bold is-black">{{ block.title }}</h2>
                        <div v-if="block.is_cocktails" class="mt3">
                          <div class="mv2" v-for="item in block.items">
                            <h3 class="f3 tl is-tablet-bold is-black">{{ item.title }}</h3>
                              <hr class="cocktail-divide">
                            <p v-if="item.description" class="margin-y20 f2 mt2 is-tablet-regular is-black">
                              <p class="f3 margin-y10">{{ item.description }}</p>
                              <p class="f3 margin-y10"><b>{{ item.description2 }}</b></p>
                              <p class="f5 margin-y10" v-if="item.description9"><em>{{item.description9}}</em></p>
                            </p>
                            <p v-if="item.description3" class="margin-y20 f2 mt2 is-tablet-regular is-black">
                
                              <p class="f3 margin-y10">{{ item.description3 }}</p>
                              <p class="f3 margin-y10"><b>{{ item.description4 }}</b></p>
                            </p>
                            <p v-if="item.description5" class="margin-y20 f2 mt2 is-tablet-regular is-black">
                
                              <p class="f3 margin-y10">{{ item.description5 }}</p>
                              <p class="f3 margin-y10"><b>{{ item.description6 }}</b></p>
                            </p>
                            <p v-if="item.description7" class="margin-y20 f2 mt2 is-tablet-regular is-black">
                
                              <p class="f3 margin-y10">{{ item.description7 }}</p>
                              <p class="f3 margin-y10"><b>{{ item.description8 }}</b></p>
                            </p>
                            <p v-if="item.description10" class="margin-y20 f2 mt2 is-tablet-regular is-black">
                
                              <p class="f3 margin-y10">{{ item.description10 }}</p>
                              <p class="f3 margin-y10"><b>{{ item.description11 }}</b></p>
                            </p>
                            <!-- <a class="db mt2 relative is-tablet-bold f15px" :href="item.link" target="_blank">More →</a> -->
                          </div>
                        </div>
                        <div v-if="block.is_magic" class="mt3">
                          <div class="mv2" v-for="item in block.items">
                            <h3 class="f3 tl is-tablet-bold is-black">{{ item.title }}</h3>
          
                            <p v-if="item.description" class="f5 mt2 is-tablet-regular is-black">
                              <h3>{{ item.description }}</h3>
                              
                            </p>
                            <a class="db mt2 relative is-tablet-bold f15px" :href="item.link" target="_blank">More →</a>
                          </div>
                        </div>
                    </div>
                  </div>


                      <!--
                      <div class="col-xs-12 col-sm-6 pb4" v-for="vendor in page.wineries_section.wineries_list">
                        <a class="flex relative flex-row items-center is-tablet-bold f15px" :href="vendor.link" :title="vendor.title" target="_blank">
                          <h3 class="is-tablet-bold is-black f20px">{{vendor.title}}</h3>
                          <simple-svg class="checkout r45" :filepath="'/uploads/checkout-arrow.svg'"></simple-svg>
                        </a>
                      </div>
                      -->
                </div>
              </div>
            </section>
        
        <!-- <div class="key-css2">
          <h1 class="is-tablet-bold is-navy spanner-change">Key:</h1>

          <div class="key-inner">
            <span
              ><h1 class="is-tablet-bold is-navy">V = VEGETARIAN</h1></span
            ><span
              ><h1 class="is-tablet-bold is-navy">VE = VEGAN</h1></span
            ><span
              ><h1 class="is-tablet-bold is-navy">GF = GLUTEN-FREE</h1></span
            ><span
              ><h1 class="is-tablet-bold is-navy">
                GGC = GOLDEN GATE CLUB
              </h1></span
            >
            <div class="db relative w-100 f22px is-tablet-regular link-bold lh-copy cms-content" v-if="page.restaurant_section.sub_text" v-html="marked(page.restaurant_section.sub_text)"></div>
          </div>
        </div> -->
        <div class="fixed top-0 left-0 right-0 bottom-0 bg-black-70" style="z-index: 100000" v-show="showGrassLandsModal">
          <div class="db center w-100">
            <div class="db absolute w-100 abs-vert-center left-0 right-0 center relative mt5">
              <section class="relative mw7 center tc">
                <h3 class="f3 mv3 is-lorano-bold is-white">Welcome to Grass Lands</h3>
                <div class="" v-show="!showNot21Message">
                  <h3 class="f4 mv3 is-lorano-bold is-white">Are you at least 21 years of age or older?</h3>
                  <div class="flex flex-row items-center justify-center relative center mv3 ">
                    <a title="Yes" id="ol20-gl-yes" class="db relative w-100 mw4 mh2 pv3 btn-generic has-orange-bg overflow-hidden link pointer" @click="userIs21Method()">
                      <span class="text">
                        Yes
                      </span>
                    </a>
                    <a title="No" id="ol20-gl-no" class="db relative w-100 mw4 mh2 pv3 btn-generic has-orange-bg overflow-hidden link pointer" @click="userIsNot21Method(); showNot21MessageMethod();">
                      <span class="text">
                        No
                      </span>
                    </a>
                  </div>
                </div>
                <div class="relative center mv3 tc" v-show="showNot21Message">
                  <h3 class="f4 mv3 is-lorano-bold is-white">Sorry! You need to be of legal age to visit.</h3>
                  <router-link title="Go Home" id="ol19-tickets-single-day-gold" class="db relative w-100 mw5 center pv3 btn-generic has-orange-bg overflow-hidden link pointer" to="/">
                    <span class="text">
                      Go Home
                    </span>
                  </router-link>
                </div>
              </section>
            </div>
          </div>
        </div>
      <h1 class="center is-tablet-bold is-navy second-title2 fs2">
                License #: EVNT-21-0000005-LIC
              </h1>
      </div>
    </template>
  </page-template>
</template>

<script>
import PageTemplate from './page-template.vue';
import AccoladesSwiper from "./accolades-swiper.vue";
import AccoladesStatic from "./accolades-static.vue";
import { Slider, SliderItem } from "vue-easy-slider";
import BeerData from '../../beer-2021.json'
export default {
  components: {
    AccoladesSwiper,
    AccoladesStatic,
    PageTemplate,
    Slider,
    SliderItem
  },
  props: ['id','pageMarkdownFileName'],
  metaInfo () {
    return {
      title: this.page.seo_title,
      titleTemplate: (titleChunk) => {
        return titleChunk ? `${titleChunk} | ` + this.$site_seo_title_suffix : this.$site_seo_title_suffix;
      },
      meta: [
        { vmid: 'description', name: 'description', content: this.page.seo_description }
      ]
    }
  },
  data () {
    return {
      mobileActive: 3,
      showGrassLandsModal: false,
      showNot21Message: false,
      beerData: BeerData,
      newArray: [],
      bgOpaciy: 0,
      bgScrollStart: 10,
      scrollPos: 0,
      swiperOptions: {
        speed: 700,
        autoplayDisableOnInteraction: false,
        loop: true,
        initialSlide: 0,
        paginationClickable: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet(index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom"></span>`;
          }
        },
        keyboardControl: true,
        navigation: {
          nextEl: ".swiper-button-next-home",
          prevEl: ".swiper-button-prev-home"
        },
        initialSlide: 0,
        spaceBetween: 0,
        centeredSlides: true,
        slidesPerView: 2.2,
        afterLoad: false,
        breakpoints: {
          540: {
            slidesPerView: 1.3
          },
          840: {
            slidesPerView: 1.8,
            loopAdditionalSlides: 1
          }
        }
      },
      parallax:null,
      window: {
        width: 0,
        height: 0
      },
      list: [
        { width: "100%", height: "100%" },
        { width: "100%", height: "100%" },
        { width: "100%", height: "100%" },
        { width: "100%", height: "100%" },
        { width: "100%", height: "100%" },
        { width: "100%", height: "100%" }
      ],
      sliderValue: 2,
      newArray: [],
      currentNumber: 0,
      timer: null,
      isWindowWidthMobile: false,
    }
  },
  computed: {
    page: function () {
      const pageData = this.$store.getters.filterPagesByName('grass-lands-partners.markdown');
      if (pageData && typeof pageData != 'undefined') return pageData[0];
      else return {}
    },
    currentImage: function() {
      return this.images[Math.abs(this.currentNumber) % this.images.length];
    },
    swiper() {
      if (this.$refs.mySwiper) return this.$refs.mySwiper.swiper;
    },
     getUserIs21: function() {
        return this.$store.getters.getUserIs21;
      },
  },
  methods : {
    userIs21Method() {
        this.$store.dispatch('userIs21', 'payload 21');
        this.showGrassLandsModal = false;
      },
      userIsNot21Method() {
        this.$store.dispatch('userIsNot21', 'payload Not 21');
      },
      showNot21MessageMethod() {
        this.showNot21Message = true;
      },
      pageLoad(){
        this.windowSize();
        this.contentHeight();
      },
      resizing(){
        this.windowSize();
        this.contentHeight();
      },
    sizing: function(){
      this.windowWidth = window.innerWidth;
      if (this.windowWidth < 768)
        this.isWindowWidthMobile = true; 
      else{
        this.isWindowWidthMobile = false; 
      }
    },

    windowSize() {
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
        if (this.window.width < 768)
          this.isWindowWidthMobile = true;
        else {
          this.isWindowWidthMobile = false;
          this.mobileActive = -1;
        }
      },
    randomNumber() {
      this.pic1 = Math.floor(Math.random() * (23 - 1) + 23);
      console.log("random num pic1 - ", this.pic1);
    },
    startRotation: function() {
      this.timer = setInterval(this.next, 3000);
    },

    stopRotation: function() {
      clearTimeout(this.timer);
      this.timer = null;
    },

    next: function() {
      this.currentNumber += 1;
    },
    prev: function() {
      this.currentNumber -= 1;
    },
    changeIndex(index) {
      this.sliderValue = index;
    },
  },
  created() {

    this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width < 768)
        this.isWindowWidthMobile = true;
      else
        this.isWindowWidthMobile = false;
    window.addEventListener('resize', this.sizing);
    window.addEventListener('load', this.sizing);
    /* Grass Lands Modal Gate */
      //Mobile

        if (this.mobileActive == 3 && this.getUserIs21 == false) {
          this.showGrassLandsModal = true;
        }
        else {
          this.showGrassLandsModal = false;
        }
      
      //Desktop
      
  },
  beforeMount() {
    //
  },
  mounted() {
     this.windowSize();
    this.startRotation();
    this.$nextTick(() => {
      //
    })


  },
  updated(){
     /* Grass Lands Modal Gate */
      //Mobile
      if (this.isWindowWidthMobile) {
        if (this.mobileActive == 3 && this.getUserIs21 == false) {
          this.showGrassLandsModal = true;
        }
        else {
          this.showGrassLandsModal = false;
        }
      }
      //Desktop
      else {
        if (this.$route.path === '/grass-lands/' && this.getUserIs21 == false) {
          //console.log('updated 1.1 - ', this.showGrassLandsModal)
          this.showGrassLandsModal = true;
        }
        else {
          this.showGrassLandsModal = false;
        }
      }
  },
  destroyed() {
    window.removeEventListener('resize', this.sizing);
    window.removeEventListener('load', this.sizing);
  }
}
</script>
